import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../shared/header/header.component';
import { LayoutService } from '../shared/services/layout.service';

@Component({
  selector: 'app-observer-view',
  templateUrl: './observer-view.component.html',
  styleUrls: ['./observer-view.component.css'],
  imports: [
    HeaderComponent,
    RouterOutlet
  ],
  standalone: true
})
export class ObserverViewComponent {
  constructor(public layoutService: LayoutService) { }
}